import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setExternalLink, setShowHomePopup } from "../redux/slice/slicePopup";

const PopUpHome = () => {
  const dispatch = useDispatch();
  const { showHomePopup, externalLink } = useSelector(
    (state) => state.popupSlice
  );
  return (
    <Modal
      className="external-link-modal home-model"
      show={showHomePopup}
      onHide={() => {
        dispatch(setExternalLink(""));
        dispatch(setShowHomePopup(false));
      }}
    >
      <Modal.Body>
        <div className="home-close-btn">
          <Button
            type="button"
            className="close"
            onClick={() => {
              dispatch(setExternalLink(""));
              dispatch(setShowHomePopup(false));
            }}
          >
            X
          </Button>
        </div>
        <div dangerouslySetInnerHTML={{ __html: externalLink }}></div>
        {/* <img
          src="https://www.india.gov.in/sites/upload_files/npi/files/spotlights/india_portal_new_version.jpg"
          alt=""
        /> */}
      </Modal.Body>
    </Modal>
  );
};

export default PopUpHome;
